// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.user.ChangePasswordResult
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class ChangePasswordResult {
  static createChangePasswordResult(errorMessage, success) {
    const retVal = new ChangePasswordResult();
    retVal.initChangePasswordResult(errorMessage, success);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createChangePasswordResult factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadu.ChangePasswordResult";
  }
  initFromJson(json, deserializeContext) {
    this.initChangePasswordResult(json.errorMessage != null ? json.errorMessage : null, json.success);
  }
  initChangePasswordResult(errorMessage, success) {
    this._errorMessage = errorMessage;
    this._success = success;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["errorMessage"] = this._errorMessage;
    retVal["success"] = this._success;
    return retVal;
  }
  get errorMessage() {
    return this._errorMessage;
  }
  set errorMessage(value) {
    this._errorMessage = value;
  }
  get success() {
    return this._success;
  }
  set success(value) {
    this._success = value;
  }
}
//# sourceMappingURL=ChangePasswordResult.js.map
